import * as abi from 'web3-eth-abi';
import { METHODS } from './constants';
let idCount = 0;
// @ts-ignore
const web3abiDecoder = abi.default;
export function decodeResult(method, result) {
    const rpcResult = result.result;
    if (rpcResult === '0x') {
        return null;
    }
    const decodedData = web3abiDecoder.decodeParameter(METHODS[method].returnEncoding, rpcResult);
    if (Array.isArray(decodedData) &&
        decodedData.length === 1 &&
        decodedData[0] === '0x') {
        return [null];
    }
    return decodedData;
}
export function constructJSONRPC(address, method, methodParam) {
    const data = methodParam
        ? METHODS[method].sig + methodParam.replace('0x', '')
        : METHODS[method].sig;
    idCount += 1;
    return {
        jsonrpc: '2.0',
        method: 'eth_call',
        params: [
            {
                to: address,
                gas: METHODS[method].gas,
                gasPrice: METHODS[method].gasPrice,
                value: METHODS[method].value,
                data,
            },
        ],
        id: idCount,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXItd3JhcHBlci11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvcHJvdmlkZXItd3JhcHBlci11dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssR0FBRyxNQUFNLGNBQWMsQ0FBQztBQUtwQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBRXRDLElBQUksT0FBTyxHQUFHLENBQUMsQ0FBQztBQUNoQixhQUFhO0FBQ2IsTUFBTSxjQUFjLEdBQUcsR0FBRyxDQUFDLE9BQU8sQ0FBQztBQUVuQyxNQUFNLFVBQVUsWUFBWSxDQUFDLE1BQWMsRUFBRSxNQUFNO0lBQ2pELE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7SUFFaEMsSUFBSSxTQUFTLEtBQUssSUFBSSxFQUFFO1FBQ3RCLE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxNQUFNLFdBQVcsR0FBRyxjQUFjLENBQUMsZUFBZSxDQUNoRCxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsY0FBYyxFQUM5QixTQUFTLENBQ1YsQ0FBQztJQUVGLElBQ0UsS0FBSyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUM7UUFDMUIsV0FBVyxDQUFDLE1BQU0sS0FBSyxDQUFDO1FBQ3hCLFdBQVcsQ0FBQyxDQUFDLENBQUMsS0FBSyxJQUFJLEVBQ3ZCO1FBQ0EsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ2Y7SUFFRCxPQUFPLFdBQVcsQ0FBQztBQUNyQixDQUFDO0FBRUQsTUFBTSxVQUFVLGdCQUFnQixDQUM5QixPQUFlLEVBQ2YsTUFBYyxFQUNkLFdBQW9CO0lBRXBCLE1BQU0sSUFBSSxHQUFHLFdBQVc7UUFDdEIsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxHQUFHLEdBQUcsV0FBVyxDQUFDLE9BQU8sQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDO1FBQ3JELENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsR0FBRyxDQUFDO0lBRXhCLE9BQU8sSUFBSSxDQUFDLENBQUM7SUFFYixPQUFPO1FBQ0wsT0FBTyxFQUFFLEtBQUs7UUFDZCxNQUFNLEVBQUUsVUFBVTtRQUNsQixNQUFNLEVBQUU7WUFDTjtnQkFDRSxFQUFFLEVBQUUsT0FBTztnQkFDWCxHQUFHLEVBQUUsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUc7Z0JBQ3hCLFFBQVEsRUFBRSxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsUUFBUTtnQkFDbEMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxLQUFLO2dCQUM1QixJQUFJO2FBQ0w7U0FDRjtRQUNELEVBQUUsRUFBRSxPQUFPO0tBQ1osQ0FBQztBQUNKLENBQUMifQ==